// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__yqmCp","empty":"ModalGraph_empty__2ziZU"};